module.exports = __webpack_public_path__ + "static/scale-model-of-ray-ash-park-in-springfield-massachusetts-3986b302448850f2b1ecf5ca7652eb18.png";